<template>
  <td class="default-table-cell" :style="custom_style" v-bind="$attrs">
    <slot></slot>
  </td>
</template>

<script lang="ts">
export default {
  props: {
    custom_style: {
      default: '',
      required: false,
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
.default-table-cell {
  height: auto;
  padding: 0.1rem 0.5rem;
  border: 1px solid #dee2e6;
}
</style>
